import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../../user.service';
import { EnvService } from 'src/app/services/env.service';
import { UniversalStorageService } from '../../../services/universal-storage.service';

@Component({
    selector: 'app-edit-photo',
    templateUrl: './edit-photo.component.html',
    styleUrls: ['./edit-photo.component.scss'],
})
export class EditPhotoComponent implements OnInit {
    imageUrl: string | ArrayBuffer | null = null;

    fileToUpload: File | null = null; // Store the selected file
    user_email: string;
    user_name: string;
    //profile_picture: string;
    profile_picture: string | ArrayBuffer | null;
    isLoading = false;
    imisid: string;
    // user_name: string | null;

    constructor(
        private http: HttpClient,
        private userService: UserService,
        private env: EnvService,
        private storageService: UniversalStorageService
    ) {
        const token = this.storageService.getItem('BEARER_TOKEN');
        if (token) {
            const tokenPayload = this.decodeToken(token);
            this.user_email = tokenPayload.data.email;
            this.imisid = tokenPayload.data.imis_id;
        }
    }
    ngOnInit() {
        this.userService
            .getProfilePicture(this.user_email)
            .subscribe((response) => {
                if (response && response['profile_picture']) {
                    this.profile_picture =
                        this.env.userProfile +
                        this.user_name +
                        '/' +
                        response['profile_picture']['user_profile_picture'];
                } else {
                    // Handle the case where 'profile_picture' is null or undefined
                }
            });
    }
    private decodeToken(token: string) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error('Invalid token format');
        }

        const tokenPayload = JSON.parse(atob(tokenParts[1]));
        return tokenPayload;
    }

    onFileSelected(event) {
        this.fileToUpload = event.target.files[0];
        if (this.fileToUpload) {
            this.isLoading = true; // Start loading
            const reader = new FileReader();

            reader.onload = (e) => {
                this.profile_picture = e.target?.result as
                    | string
                    | ArrayBuffer
                    | null;
                this.isLoading = false; // Stop loading
            };

            reader.readAsDataURL(this.fileToUpload);
        }
    }

    onSaveButtonClick() {
        if (this.fileToUpload) {
            this.user_name;
            const formData = new FormData();
            formData.append('image', this.fileToUpload);
            formData.append('email', this.user_email);
            formData.append('imis_id', this.imisid);
            this.userService.uploadImage(formData).subscribe(
                (response) => {
                    this.profile_picture = `${this.env.userProfile}${this.imisid}/profile_picture.${response.extension}`;
                },
                (error) => {
                    console.error('Image upload failed:', error);
                }
            );
        } else {
            console.error('No image selected');
        }
    }
}
